import React, { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

const EnquiryOnlyWrapper = ({ pageRoute, children }) => {
    const { isEnquiryOnly } = useAuth();
    const readOnly = isEnquiryOnly(pageRoute);
    const containerRef = useRef(null);

    // Direct DOM manipulation approach for better coverage
    useEffect(() => {
        if (!readOnly || !containerRef.current) return;

        const container = containerRef.current;

        // Get all interactive elements
        const interactiveElements = container.querySelectorAll(
            'button:not(.read-only-allowed), ' +
            'input:not(.read-only-allowed), ' +
            'select:not(.read-only-allowed), ' +
            'textarea:not(.read-only-allowed), ' +
            'a:not(.read-only-allowed)'
        );

        // Disable all interactive elements
        interactiveElements.forEach(el => {
            // Save original state for cleanup
            el._originalDisabled = el.disabled;
            el._originalReadOnly = el.readOnly;

            // Apply disabled/readonly
            if (el.tagName.toLowerCase() === 'a') {
                el.style.pointerEvents = 'none';
                el.style.cursor = 'not-allowed';
                el.style.opacity = '0.7';
                el.setAttribute('aria-disabled', 'true');

                // Prevent default on click
                el._originalOnClick = el.onclick;
                el.onclick = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                };
            } else {
                el.disabled = true;
                if (el.tagName.toLowerCase() === 'input' || el.tagName.toLowerCase() === 'textarea') {
                    el.readOnly = true;
                }
                el.classList.add('read-only-input');
            }
        });

        // Handle forms to prevent submission
        const forms = container.querySelectorAll('form:not(.read-only-allowed)');
        forms.forEach(form => {
            form._originalOnSubmit = form.onsubmit;
            form.onsubmit = (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('Form submission prevented in read-only mode');
                return false;
            };
        });

        // Cleanup function
        return () => {
            interactiveElements.forEach(el => {
                if (el.tagName.toLowerCase() === 'a') {
                    el.style.pointerEvents = '';
                    el.style.cursor = '';
                    el.style.opacity = '';
                    el.removeAttribute('aria-disabled');
                    el.onclick = el._originalOnClick;
                } else {
                    el.disabled = el._originalDisabled;
                    if (el.tagName.toLowerCase() === 'input' || el.tagName.toLowerCase() === 'textarea') {
                        el.readOnly = el._originalReadOnly;
                    }
                    el.classList.remove('read-only-input');
                }
            });

            forms.forEach(form => {
                form.onsubmit = form._originalOnSubmit;
            });
        };
    }, [readOnly]);

    if (!readOnly) {
        return children;
    }

    return (
        <div className="enquiry-only-container" ref={containerRef}>
            {children}
            <div className="enquiry-only-banner">
                <div className="banner-content">
                    <span className="message">You are viewing this page in read-only mode</span>
                </div>
            </div>
        </div>
    );
};

export default EnquiryOnlyWrapper;